import React, { useEffect } from 'react'
import { func, shape, bool, number, oneOfType, string } from 'prop-types'
import profileType from 'Utils/proptypes/profile'
import asyncStatusType from 'Utils/proptypes/asyncStatus'

import { Route, Redirect, useHistory } from 'react-router-dom'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { loadCurrentUser } from 'Store/currentUser/actions'

import AccessToken from 'Utils/AccessToken'
// import API from 'Utils/API'

const ProtectedRoute = ({ profile, profileErr, status, loadProfile, children, ...rest }) => {
  const isAuthenticated = AccessToken.get()
  const history = useHistory()

  useEffect(() => {
    loadProfile()
  }, [loadProfile])

  useEffect(() => {
    if (status === 'failed') {
      if (profileErr.status === 401) {
        AccessToken.remove()
        history.replace('/signin')
      }
    }
  }, [profileErr, status, history])

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/signin",
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

ProtectedRoute.propTypes = {
  profile: profileType,
  profileErr: shape({
    status: oneOfType([number, bool]),
    message: string,
  }),
  status: asyncStatusType,
  loadProfile: func,
}

const mapStateToProps = state => ({
  profile: state.currentUser.data,
  profileErr: state.currentUser.error,
  status: state.currentUser.status,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  loadProfile: loadCurrentUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute)
